import {Component, Input, OnInit} from '@angular/core';
import {Event} from '@api/models/event/event';
import {EventsHttpService, EventsTargetType} from '@api/http/events/events-http.service';
import {CountryService} from '@core/services/country.service';
import {UrlService} from '@utils/services/url/url.service';
import {HomeRoutes} from '@app/routes/home.routes';
import {StateService} from '@core/services/state.service';

@Component({
  selector: 'app-current-games',
  templateUrl: './current-games.component.html',
  styleUrls: ['./current-games.component.scss']
})
export class CurrentGamesComponent implements OnInit {

  public loading = false;
  public events: Partial<Event>[];
  public gamesLink: string;
  @Input() public openLinksInNewTab = false;
  @Input() public readableId: string;
  @Input() private teamId: string;
  @Input() private leagueId: string;

  constructor(private eventsHttpService: EventsHttpService) {}

  public async ngOnInit(): Promise<void> {
    if (this.teamId) {
      await this.getEventsForTeam();
    } else if (this.leagueId) {
      await this.getEventsForLeague();
    }
    if (this.readableId) {
      this.gamesLink = `https://${this.readableId}.${UrlService.WebHost}/${HomeRoutes.games.root}`;
    }
    if (this.teamId || this.leagueId) {
      return;
    }
    this.getLiveEvents();
  }

  private async getEventsForTeam(): Promise<void> {
    this.events = await this.eventsHttpService.getEventsForTarget(
      EventsTargetType.Team, this.teamId, 2, 2);
    if (!this.readableId && this.events?.length > 0) {
      const eventTeams = this.events[0].teams;
      const team = eventTeams.home.teamid === this.teamId ? eventTeams.home : eventTeams.away;
      this.readableId = team.readable_id;
    }
  }

  private async getEventsForLeague(): Promise<void> {
    this.events = await this.eventsHttpService.getEventsForTarget(
      EventsTargetType.League, this.leagueId, 2, 2);
  }

  private async getLiveEvents(): Promise<void> {
    const response = await this.eventsHttpService.getLatestEventsForRegion('international', 4);
    if (response?.data?.length > 0) {
      this.events = response.data;
    }
  }
}
